import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import flowchart from '../images/flowchart.png';
import logo from '../images/logo.png';
import '../styles/LoginPage.scss';
import logger from '../utils/logger';
import Spacers from "./Spacers";
const LoginPage = ({ 
  handleLogin, 
  error, 
  setError,
  username, 
  setUsername, 
  password, 
  setPassword,
  showPassword,
  setShowPassword,
  showResendVerification,
  handleResendVerification,
  storeToken,
  storeUserData,
  navigate
}) => {
  const location = useLocation();
  const message = location.state?.message;
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  const testimonials = [
    
    {
      quote: "My students loved it",
      author: "Secondary School Teacher"
    },
    {
      quote: "It's such a great resource, I'm actually so shocked",
      author: "Leaving Cert Student"
    },
    {
      quote: "oh my god this is my dream come true",
      author: "Secondary School Teacher"
    },
    {
      quote: "Extremely useful",
      author: "Leaving Cert Student"
    },
    {
      quote: "I think this could be revolutionary",
      author: "Secondary School Teacher"
    }
    
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setIsTransitioning(true);
        setTimeout(() => {
          setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
          setIsTransitioning(false);
        }, 300);
      }
    }, 3500);

    return () => clearInterval(interval);
  }, [isPaused, testimonials.length]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ 
          identifier: username,
          password: password 
        }),
      });

      const data = await response.json();
      
      if (response.ok) {
        // Log the token to see its structure
        logger.info('Token received:', data.access_token);
        
        // Make sure we're getting the token in the right format
        const token = data.token || data.access_token;
        storeToken(token);


        // Fetch user data after successful login
        const userResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/profile`, {
          headers: {
            'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}`,
          },
        });
        const userData = await userResponse.json();
        storeUserData(userData);
        navigate('/');
      } else {
        // Handle specific error types
        if (data.errorType === 'invalid_user') {
          setError(data.error);
        } else if (data.errorType === 'invalid_password') {
          setError(data.error);
        } else {
          setError(data.error || 'Login failed');
        }
      }
    } catch (error) {
      logger.error('Login error:', error);
      setError('An error occurred during login');
    }
  };

  const handlePrevious = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handleNext = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
      setIsTransitioning(false);
    }, 300);
  };

  return (
    <div>
      <div className="header">
        <img 
          src={logo} 
          alt="Pulc AI Logo" 
          className="logo"
        />
        <div className="header-links">
          <Link to="/about" className="header-link">About Us</Link>
          <Link to="/register" className="header-link signup">Sign Up</Link>
        </div>
      </div>
      <Spacers size="one-hundred-and-twenty-eight" />
      <div className="container">
        <div className="content">
          <div className="login-section">
            <div className="login-form-container">
              <form onSubmit={handleLoginSubmit}>
                {/* Username Input */}
                <input
                  type="text"
                  placeholder="Username or Email"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  className="form-input"
                />

                <div className="password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="form-input"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle"
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>

                <button 
                  type="button"
                  onClick={() => window.location.href = '/register'}
                  className="signup-button"
                >
                  Sign up for free
                </button>

                <button type="submit" className="login-button">
                  Log In
                </button>
              </form>

              <div className="forgot-password">
                <Link to="/forgot-password">Forgot your password?</Link>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            {/* Resend Verification */}
            {showResendVerification && (
              <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <button onClick={handleResendVerification} className="login-button">
                  Resend Verification Email
                </button>
              </div>
            )}
          </div>

          <div className="image-section">
            <div className="video-container">
              <iframe
                className="video-iframe"
                src="https://www.youtube.com/embed/7Q2A2XgZOdc"
                title="Pulc Tutorial"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 